import { Map } from 'maplibre-gl';

import { AllSourceProperties } from '@/hooks/map-box/config/sourceConfig';

import { addSource } from '../asyncMapbox';

export interface GenericSourceOptions extends AllSourceProperties {
  sourceId: string;
}

/** Creates a source and adds it to mapbox */
const createGenericSource = async (
  map: Map,
  options: GenericSourceOptions,
  /** Append .pbf to the end of the tile url */
  appendPbf: boolean = true
) => {
  const { sourceId, promoteId, url, maxZoom, minZoom } = options;

  if (!url) return undefined;

  const source = await addSource(map, sourceId, {
    maxzoom: maxZoom,
    minzoom: minZoom,
    promoteId,
    tiles: [`${url}{z}/{x}/{y}${appendPbf ? '.pbf' : ''}`],
    type: 'vector',
  });

  return source;
};

export default createGenericSource;
